/**
 * Hard delete, no undo — the app's one major-toast anchor (MajorToast), same
 * convention as MemberRemovedToast/DeleteToast/DomainToast.
 */
import React from "react";
import MajorToast from "../../component/Toast/MajorToast";

const AUTO_DISMISS_MS = 6000;

const UserDeletedToast = ({ name, onDismiss }) => (
  <MajorToast
    title="User deleted"
    text={name ? `${name} has been deleted.` : "The user has been deleted."}
    duration={AUTO_DISMISS_MS}
    onDismiss={onDismiss}
  />
);

export default UserDeletedToast;
